module.exports = __webpack_public_path__ + "4ce7b7e44025cc60888086ddeda36dc7.pdf";